import { Component, inject, output, signal, ViewChild } from '@angular/core';
import { ModalComponent } from '@peca/design-system';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastService } from '@peca/commons';

export interface OnConfirmProps {
  orderId: string;
  nfCode: string;
}

@Component({
  selector: 'peca-fiscal-panel-modal-send-omie',
  templateUrl: './fiscal-panel-modal-send-omie.component.html',
  styleUrls: ['./fiscal-panel-modal-send-omie.component.scss'],
  standalone: false,
})
export class FiscalPanelModalSendOmieComponent {
  @ViewChild('modal') modal!: ModalComponent;

  confirm = output<OnConfirmProps>();
  orderId = signal('');

  toast = inject(ToastService);
  form = new FormGroup({
    code: new FormControl<string>(''),
  });

  get formValue() {
    return {
      code: this.form.get('code')?.value || '',
    };
  }

  open(orderId: string) {
    this.orderId.set(orderId);
    this.modal.open();
  }

  onClickConfirm(orderId: string, nfCode: string) {
    this.confirm.emit({ orderId, nfCode: String(nfCode) });
    this.modal.close();
  }
}
